import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AppLauncher/app-launcher';
import accessibleStyles from '@patternfly/react-styles/css/utilities/Accessibility/accessibility';
import { ApplicationLauncherIcon } from './ApplicationLauncherIcon';
import { ApplicationLauncherText } from './ApplicationLauncherText';
import ExternalLinkAltIcon from '@patternfly/react-icons/dist/js/icons/external-link-alt-icon';
import { ApplicationLauncherItemContext } from './ApplicationLauncherItemContext';
export var ApplicationLauncherContent = function ApplicationLauncherContent(_ref) {
  var children = _ref.children;
  return React.createElement(ApplicationLauncherItemContext.Consumer, null, function (_ref2) {
    var isExternal = _ref2.isExternal,
        icon = _ref2.icon;
    return React.createElement(React.Fragment, null, icon && React.createElement(ApplicationLauncherIcon, null, icon), icon ? React.createElement(ApplicationLauncherText, null, children) : children, isExternal && React.createElement(React.Fragment, null, React.createElement("span", {
      className: css(styles.appLauncherMenuItemExternalIcon)
    }, React.createElement(ExternalLinkAltIcon, null)), React.createElement("span", {
      className: css(accessibleStyles.screenReader)
    }, "(opens new window)")));
  });
};